import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import {
  addEmailFieldChange,
  addNumberFieldChange,
  getCompanyNumbers,
  uploadFile,
} from '../../actions/Numbers';
import util from '../../lib/utils';
import CompanyAutocomplete from '../CompanyAutocomplete';
import MultiInput from './../MultiInput';
import NumberTypeSelect from './NumberTypeSelect';
import Select from 'react-select'
import UsersAutocomplete from './UsersAutocomplete';
import remove from '../../Res/Icon/remove.png';
import { toast } from 'react-toastify';
import Toggle from '../Toggle';
import { hiddenNumberCarrierOptions, numberCarrierOptions } from '../../utils/constants';
import { getPermissionForComponent } from '../../utils/permissionsUtils';

class AddNumberForm extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.onNumberChange = this.onNumberChange.bind(this);
    this.state = {
      checkedBox: false,
      numDigits: 1,
      spoofType: 'same',
      numberCarrierChangeAccess: false
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
      await this.props.getCompanyNumbers(this.token, user.company && user.company._id);
      this.props.addEmailFieldChange(this.props.email.emails);
      this.props.addNumberFieldChange('assignedTo', user._id);
      this.props.addNumberFieldChange('company', user.company._id);
    }
    this.props.addNumberFieldChange('numDigits', '1');
    this.props.addNumberFieldChange('cidOverride', '+');
    this.props.addNumberFieldChange('forwardNumbers', []);
    this.props.addNumberFieldChange('carrier', numberCarrierOptions[0]);
    const numberCarrierChangeAccessPermission = getPermissionForComponent('numberCarrierChangeAccess',user.permissionsGroup);
    this.setState({ numberCarrierChangeAccess: numberCarrierChangeAccessPermission })

    // this.props.addNumberFieldChange('assignedTo', {'_id': user._id});
  }

  onNumberChange(faxNumber) {
    this.props.addNumberFieldChange('number', faxNumber);
  }

  onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const { addEmailFieldChange, addNumberFieldChange } = this.props;
    if (suggestion) {
      let uid = true;
      await this.props.getCompanyNumbers(this.token, suggestion._id, uid);
      addNumberFieldChange(name, suggestion._id);
      addEmailFieldChange(this.props.email.emails);
      let assigned = this.props.emails && this.props.emails[0];
      addNumberFieldChange('assignedTo', { email: assigned?.email, _id: assigned?._id });
    } else {
      addEmailFieldChange([]);
      addNumberFieldChange('company', value);
      addNumberFieldChange('userName', '');
    }
  };

  onAddedEmailChange = ({ name, suggestion }) => {
    if (suggestion) {
      this.props.addNumberFieldChange(name, suggestion._id);
    } else {
      this.props.addNumberFieldChange(name, '');
    }
  };

  onNumberTypeSelect = numberType => {
    this.props.addNumberFieldChange('type', numberType?.value);
  };

  componentDidUpdate(prevProps) {
    console.log("carrier", numberCarrierOptions)
    const { type, addNumberFieldChange } = this.props;
    if (prevProps.type !== type) {
      if (type === 'callIdMask') {
        addNumberFieldChange('carrier', numberCarrierOptions[7]);
      } else if(type === 'tollFree') { 
        addNumberFieldChange('carrier', numberCarrierOptions[6]);
      } else {
        addNumberFieldChange('carrier', numberCarrierOptions);
      }
    }
  }

  onUserTypeSelect = numberType => {
    const number = numberType ? numberType?.value : '';
    if (number !== '' && number !== undefined) {
      this.props.addNumberFieldChange('assignedTo', { email: number.email, _id: number._id });
    }
  };
  onAllowedUserSelect = ({ suggestion }) => {
    const { number } = this.props;
    if (suggestion !== null) {
      var addArray = true;
      number.allowedUsers.forEach((item, idx) => {
        if (item._id === suggestion._id) {
          addArray = false;
        }
      });
      if (addArray) {
        this.onAddedArrChange([...number.allowedUsers, suggestion], 'allowedUsers');
      }
    }
  };
  onAddedUserChange = ev => {
    const { name, value } = ev.target;
    this.props.addNumberFieldChange(name, value);
    this.props.addNumberFieldChange('cidOverride', value);
  };

  onAddedArrChange = (ev, type) => {
    if (this.props.type === 'ringDown') {
      if (ev.length > 1) {
        toast.error("You can't add more than one number.");
      } else {
        this.props.addNumberFieldChange(type, ev);
      }
    } else {
      this.props.addNumberFieldChange(type, ev);
    }
  };

  onAddedArrNumChange = ev => {
    const { name, value } = ev.target;
    this.props.addNumberFieldChange(name, [value]);
  };

  onAddedNumberChange = ev => {
    const { name, value } = ev.target;
    const reg = /^[+]*[0-9]{1,11}$/g;
    if (reg.test(value)) {
      this.props.addNumberFieldChange(name, value);
    }
  };

  onFwdNumberChange = ev => {
    const { name, value } = ev.target;
    const reg = /^[+]*[0-9]{1,11}$/g;
    if (reg.test(value)) {
      this.props.addNumberFieldChange(name, [value]);
    }
  };

  onAddConfirmationEmail = e => {
    this.props.addNumberFieldChange('confirmationEmail', e.target.value);
  };

  setCheckedBox = e => {
    this.setState({ checkedBox: e });
    this.props.addNumberFieldChange('spoofIncomingCid', e);
  };

  handleNumberDigit = e => {
    if (e.target.value.length <= 1) {
      if (e.target.value >= 0 && e.target.value <= 3) {
        if (e.target.value == 0) {
          this.setState({ numDigits: 1 }, () => {
            this.props.addNumberFieldChange('numDigits', 1);
          });
        } else {
          this.setState({ numDigits: e.target.value }, () => {
            this.props.addNumberFieldChange('numDigits', this.state.numDigits);
          });
        }
      } else {
        this.setState({ numDigits: 1 }, () => {
          this.props.addNumberFieldChange('numDigits', 1);
        });
      }
    }
  };

  handleNumberType = (e, type) => {
    this.setState({ [e.target.name]: type });
    this.props.addNumberFieldChange(e.target.name, type);
  };

  removeValue = e => {
    const { number } = this.props;
    const valuesWIthRemoved = number.allowedUsers.filter((val, idx) => idx !== e);
    this.onAddedArrChange(valuesWIthRemoved, 'allowedUsers');
  };

  render() {
    const { companies, type, number, emails, user, carrier } = this.props;
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                <Input
                  required
                  type="text"
                  name="number"
                  value={number.number}
                  onChange={this.onAddedNumberChange}
                  maxLength={12}
                />
              </Col>
              <Col sm={3}>
                <Label for="type" sm={12}>
                  Type
                </Label>
                <NumberTypeSelect
                  required
                  name="type"
                  onTypeSelect={this.onNumberTypeSelect}
                  selectedType={type}
                  comingFrom="number"
                  includeCallIdMask={true}
                />
              </Col>
              { this.state.numberCarrierChangeAccess && (
                <Col sm={3}>
                  <Label for="type" sm={12}>
                    Carrier Type
                  </Label>
                  <Select
                    options={numberCarrierOptions}
                    onChange={option => this.props.addNumberFieldChange('carrier', option)}
                    isOptionDisabled={option =>
                      hiddenNumberCarrierOptions(option.value, this.state.numberCarrierChangeAccess)
                    }
                    isDisabled={this.state.numberCarrierChangeAccess === 'read'}
                    value={carrier}
                    form="carrier"
                  />
                </Col>
              )}

            </FormGroup>
            {user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <CompanyAutocomplete
                    placeholder="Filter Company..."
                    companies={companies.docs || []}
                    onChange={this.onAddedCompanyChange}
                  />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {emails.length > 0 ? (
                    <UsersAutocomplete
                      searchTerm={emails[0].email}
                      callsItem={emails || []}
                      placeholder="User..."
                      calls={emails || []}
                      onChange={this.onUserTypeSelect}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Choose the company
                    </Alert>
                  )}
                </Col>
              </FormGroup>
            ) : (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <Input value={user.company && user.company.name} readOnly />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {emails.length > 0 ? (
                    <UsersAutocomplete
                      searchTerm={emails[0].email}
                      callsItem={emails || []}
                      placeholder="User..."
                      calls={emails || []}
                      onChange={this.onUserTypeSelect}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Choose the company
                    </Alert>
                  )}
                </Col>
              </FormGroup>
            )}
            <FormGroup row></FormGroup>
            {type === 'fax' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Email(s)
                    </Label>
                    <MultiInput
                      inputData={number.emails || []}
                      onChange={e => {
                        this.onAddedArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="email" sm={12}>
                      Fallback email(s)
                    </Label>
                    <MultiInput
                      inputData={number.fallbackEmails || []}
                      onChange={e => {
                        this.onAddedArrChange(e, 'fallbackEmails');
                      }}
                      validator={util.validateEmail}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col name="forwardUris" sm={6}>
                    <Label for="type" sm={12}>
                      {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                    </Label>
                    <MultiInput
                      inputData={(number.forwardUris && number.forwardUris) || []}
                      onChange={e => {
                        this.onAddedArrChange(e, 'forwardUris');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="savefaxes" sm={12}>
                      Epik Cloud Based Fax Storage
                    </Label>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={number.savefaxes || false}
                        onToggle={() => {
                          if (number && number.forwardUris.length !== 0) {
                            this.onAddedArrChange(!!!number.savefaxes, 'savefaxes');
                          } else {
                            toast.info('Forward URI not configured!');
                            console.log('not configured');
                          }
                        }}
                      />
                    </Col>
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'vmail' && (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    Notification email(s)
                  </Label>
                  <MultiInput
                    inputData={number.fallbackEmails || []}
                    onChange={e => {
                      this.onAddedArrChange(e, 'fallbackEmails');
                    }}
                    validator={util.validateEmail}
                  />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    Notification number(s)
                  </Label>
                  <MultiInput
                    inputData={number.forwardNumbers || []}
                    onChange={e => {
                      this.onAddedArrChange(e, 'forwardNumbers');
                    }}
                  />
                </Col>
              </FormGroup>
            )}
            {type === 'dialout' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Allowed number(s)
                    </Label>
                    <MultiInput
                      inputData={number.allowedNumbers || []}
                      onChange={e => {
                        this.onAddedArrChange(e, 'allowedNumbers');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Forward number
                    </Label>
                    <Input
                      required
                      type="text"
                      name="forwardNumbers"
                      value={number.forwardNumbers || []}
                      onChange={this.onAddedArrNumChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Caller ID
                    </Label>
                    <Input
                      required
                      type="text"
                      name="cid"
                      value={number.cid || []}
                      onChange={this.onAddedUserChange}
                    />
                  </Col>
                  <Col sm={6}>
                    <Row>
                      <Col sm={12}>
                        <Label for="spoofIncomingCid" sm={6}>
                          <Input
                            type="checkbox"
                            id="spoofIncomingCid"
                            onChange={() => this.setCheckedBox(!this.state.checkedBox)}
                            checked={this.state.checkedBox}
                            disabled={
                              (number.cid && number.cid.length < 10) ||
                              number.cid === '' ||
                              number.cid === undefined
                            }
                          />
                          Spoof cid
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'prepend')}
                            disabled={!this.state.checkedBox}
                          />
                          prepend
                        </Label>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'append')}
                            disabled={!this.state.checkedBox}
                          />
                          append
                        </Label>
                        <Label check sm={6}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'same')}
                            disabled={!this.state.checkedBox}
                          />
                          Same called number
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <Label sm={4} for="numDigits" style={{ minWidth: '120px', margin: 0 }}>
                          Number of digits
                        </Label>
                        <Input
                          disabled={this.state.spoofType === 'same' ? true : false}
                          type="number"
                          id="numDigits"
                          name="numDigits"
                          onChange={this.handleNumberDigit}
                          value={this.state.numDigits}
                          max={3}
                          min={1}
                        />
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
              </>
            )}
            {type !== 'vmail' &&
            type !== 'dialout' &&
            type !== 'unassigned' &&
            type !== 'fax' &&
            type !== 'forward' ? (
              <FormGroup row>
                <Col name="forwardUris" sm={6}>
                  <Label for="type" sm={12}>
                    {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                  </Label>
                  <MultiInput
                    inputData={(number.forwardUris && number.forwardUris) || []}
                    onChange={e => {
                      this.onAddedArrChange(e, 'forwardUris');
                    }}
                  />
                </Col>
              </FormGroup>
            ) : null}

            {type === 'fax' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Confirmation email
                  </Label>
                  {number && number.forwardUris.length !== 0 ? (
                    <Input
                      type="email"
                      placeholder="please specify"
                      value={number.confirmationEmail}
                      onChange={this.onAddConfirmationEmail}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Forward URI not configured
                    </Alert>
                  )}
                </Col>
                <Col sm={6}>
                  <Label for="deliveryConfirmations" sm={12}>
                    Delivery Confirmations
                  </Label>
                  <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      value={number.faxDeliveryConfirmation}
                      onToggle={() => {
                        if (number && number.forwardUris.length !== 0) {
                          this.onAddedArrChange(
                            !number.faxDeliveryConfirmation,
                            'faxDeliveryConfirmation',
                          );
                        } else {
                          toast.info('Forward URI not configured!');
                          console.log('not configured');
                        }
                      }}
                    />
                  </Col>
                </Col>
              </FormGroup>
            ) : null}

            {type === 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Forward Number
                  </Label>
                  <Input
                    required
                    type="text"
                    name="forwardNumbers"
                    value={number?.forwardNumbers ? number.forwardNumbers[0] : ''}
                    onChange={this.onFwdNumberChange}
                    maxLength={12}
                  />
                </Col>
              </FormGroup>
            ) : null}
            <FormGroup row>
              <Col sm={6}>
                <Label for="type" sm={12}>
                  Allowed User(s)
                </Label>
                {emails.length > 0 ? (
                  <UsersAutocomplete
                    searchTerm={emails[0].email}
                    allowedUsers={true}
                    callsItem={emails || []}
                    placeholder="Allowed users"
                    calls={emails || []}
                    onChange={this.onAllowedUserSelect}
                  />
                ) : (
                  <Alert colSpan={2} color="info" className="price-not-found-alert">
                    Choose the company
                  </Alert>
                )}
                <div className="email-list">
                  {number.allowedUsers.map((value, idx) => {
                    return (
                      <div className="multi-input-item" key={value._id}>
                        <span className="item">{value.email}</span>
                        <img
                          className="remove-icon"
                          src={remove}
                          onClick={() => this.removeValue(idx)}
                          alt="remove"
                        />
                      </div>
                    );
                  })}
                </div>
              </Col>
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  numbers: state.AppState.numbers,
  number: state.UIState.numbers.addNumber,
  company: state.UIState.numbers.addNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.addNumber.type,
  carrier: state.UIState.numbers.addNumber.carrier,
  email: state.UIState.numbers.filterNumbersByCompany.number,
  emails: state.UIState.numbers.addNumberFieldChange,
});

const mapDispatchToProps = dispatch => ({
  addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
  addEmailFieldChange: emails => dispatch(addEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNumberForm);
